export const CRYSTALLIZE_CUSTOMER_META_NUKI_CLUB_KEY = 'Nuki Club';

export const CRYSTALLIZE_CATALOGUE_API_URL = process.env.CRYSTALLIZE_CATALOGUE_API_URL ?? '';

// Topics under this path scope a document to specific countries (e.g. `/countries/de`).
export const COUNTRIES_TOPIC_PREFIX = '/countries/';

export enum WarehouseDetailIds {
  MinimumDeliveryTime = 'minimum-delivery-time',
  MaximumDeliveryTime = 'maximum-delivery-time',
  ExpressMinimumDeliveryTime = 'express-minimum-delivery-time',
  ExpressMaximumDeliveryTime = 'express-maximum-delivery-time',
  FallbackMinimumDeliveryTime = 'fallback-minimum-delivery-time',
  FallbackMaximumDeliveryTime = 'fallback-maximum-delivery-time',
  FallbackStockThreshold = 'fallback-stock-threshold',
  OutOfStockThreshold = 'out-of-stock-threshold',
  ProMinimumDeliveryTime = 'pro-minimum-delivery-time',
  ProMaximumDeliveryTime = 'pro-maximum-delivery-time',
  ProExpressMinimumDeliveryTime = 'pro-express-minimum-delivery-time',
  ProExpressMaximumDeliveryTime = 'pro-express-maximum-delivery-time',
  ProFallbackMinimumDeliveryTime = 'pro-fallback-minimum-delivery-time',
  ProFallbackMaximumDeliveryTime = 'pro-fallback-maximum-delivery-time',
  B2CAvailable = 'b2c-available',
  ProShopAvailable = 'pro-shop-available',
}

export enum CrystallizeProductTypeValues {
  Physical = 'Physical',
  RemoteAccess = 'Remote Access',
  GuaranteePlus = 'Guarantee Plus',
  SmartHosting = 'Smart Hosting',
  SmartHostingRenewal = 'Smart Hosting Renewal',
  Shipping = 'Shipping',
  SmartLock = 'Smart Lock',
  Adapter = 'Adapter',
}

export const isPhysicalProduct = (productType?: string | null) =>
  productType &&
  (productType === CrystallizeProductTypeValues.Physical ||
    productType === CrystallizeProductTypeValues.SmartLock ||
    productType === CrystallizeProductTypeValues.Adapter);

export const CrystallizeProductTypeDefault = 'Physical';

export enum CrystallizeBundlesExternalReferences {
  SmartLockPro5WithGPlus = 'Upgrade0225GeminiGPlus',
  SmartLockPro5WithDoorSensor = 'Upgrade0225GeminiDS',
  AdapterExchange = 'adapterExchange',
  CableExchange = 'CableExchangeBundle',
  CableExchangeUS = 'CableExchangeBundleUS',
  OpenerSet = 'openerset220745',
  KP2NFC = 'kp2nfc',
  Kp2NfcTamperExchange = 'kp2_nfc_tamper_exchange',
  Kp2NfcTamperExchangeUS = 'kp2_nfc_tamper_exchange_us',
}

// Cable exchange ships under two Crystallize bundle documents (ROTW + US) with
// distinct external references but a single shared UpgradeProgramType, so the
// 1x-per-smartlock cap spans regions. Use this set to identify either bundle
// across the checkout/shipping flows.
export const CABLE_EXCHANGE_BUNDLE_EXT_REFS: ReadonlySet<string> = new Set<string>([
  CrystallizeBundlesExternalReferences.CableExchange,
  CrystallizeBundlesExternalReferences.CableExchangeUS,
]);

// Same as cable exchange: one bundle per region, one shared upgrade program.
export const KP2NFC_TAMPER_EXCHANGE_BUNDLE_EXT_REFS: ReadonlySet<string> = new Set<string>([
  CrystallizeBundlesExternalReferences.Kp2NfcTamperExchange,
  CrystallizeBundlesExternalReferences.Kp2NfcTamperExchangeUS,
]);

// Exchange bundles whose orders get the free Nuki Club shipping option.
export const FREE_SHIPPING_EXCHANGE_BUNDLE_EXT_REFS: ReadonlySet<string> = new Set<string>([
  CrystallizeBundlesExternalReferences.AdapterExchange,
  ...Array.from(CABLE_EXCHANGE_BUNDLE_EXT_REFS),
  ...Array.from(KP2NFC_TAMPER_EXCHANGE_BUNDLE_EXT_REFS),
]);

export enum CrystallizeSubscriptionMetaSubscriptionStatusValues {
  Pending = 'Pending',
  Initial = 'Initial',
  InitialPendingCancellation = 'Initial Pending Cancellation',
  Recurring = 'Recurring',
  RecurringPendingCancellation = 'Recurring Pending Cancellation',
  RecurringFailedPayment = 'Recurring Failed Payment',
  RecurringFailedPaymentPendingCancellation = 'Recurring Failed Payment Pending Cancellation',
  Cancelled = 'Cancelled',
  OnHold = 'On Hold',
  Expired = 'Expired',

  Unknown = 'Unknown',
}
